export enum CsvImportRoutes {
  MAIN = '/dashboard/:teamId/import',
  PREVIEW = '/dashboard/:teamId/import/preview',
  REVIEW = '/dashboard/:teamId/import/review',
}
